import { Button } from "primereact/button";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import "./ToolTip.css";

export interface TooltipProps {
  headingId: string;
  paragraphIds: string[];
  firstParagraphBackgroundColor?: string;
  tooltipRight?: string; // new prop for right positioning
  tooltipWidth?: string; // new prop for width
  tooltipTop?: string; // new prop for top positioning
}

function Tooltip({
  headingId,
  paragraphIds,
  firstParagraphBackgroundColor,
  tooltipRight = "50px", // default value
  tooltipWidth = "300px", // default value
  tooltipTop = "-50px", // default value
}: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);

  const toggleTooltip = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div style={{ position: "relative" }}>
      <Button
        icon="pi pi-question-circle"
        onClick={toggleTooltip}
        className="readysize-tooltip-container"
      />

      {isVisible && (
        <div
          className="tooltip-content-container"
          style={{
            position: "absolute",
            backgroundColor: "white",
            padding: "15px 25px 15px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            zIndex: 1000,
            right: tooltipRight, // using the new prop
            width: tooltipWidth, // using the new prop
            top: tooltipTop, // using the new prop
          }}
        >
          <div>
            <h4 className="rs-habilitado-btn-h4">
              <FormattedMessage id={headingId} />
            </h4>
            {/* Apply background color style to the first paragraph if provided */}
            <p
              style={{ backgroundColor: firstParagraphBackgroundColor }}
              className="rs-habilitado-btn"
            >
              <FormattedMessage id={paragraphIds[0]} />
            </p>
            <p className="rs-habilitado-btn-info">
              <FormattedMessage id={paragraphIds[1]} />
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Tooltip;
